import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Input, Icon, Loader, Button} from 'semantic-ui-react';
import {tabKeyCode, enterKeyCode} from '../../../common/constants/keyCodes';
import {toUpperCase} from '../../../common/util/fieldsNormalization';
import {Actions} from '../../../common/actions';
import NewLocationSearchModal from './locationSearch';
import NewReservedLocationsSearchModal from './reservedLocationsSearch';
import ShowInvoicesModal from './modal/showInvoices';
import ShowReplacementPartModal from './modal/replacementPart';

class TableBody extends Component {
  constructor(props) {
    super(props);
    this.renderRow = this.renderRow.bind(this);
  }

  renderFields(fields) {
    const {loadingAssignmentsList} = this.props;
    if (loadingAssignmentsList) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return fields.map((field, index) => this.renderRow(index, field));
  }

  renderRow(index, field) {
    return (
      <Table.Row key={index}>
        <Table.Cell width={2}>{this.renderPartCode(index, field)}</Table.Cell>
        <Table.Cell>{field.partName}</Table.Cell>
        <Table.Cell textAlign='right'>{field.stock}</Table.Cell>
        <Table.Cell>{field.icc}</Table.Cell>
        <Table.Cell>
          <ShowInvoicesModal invoices={field.invoices || []} />
        </Table.Cell>
        <Table.Cell>{field.lastLocation}</Table.Cell>
        <Table.Cell>{field.location}</Table.Cell>
        <Table.Cell>
          {this.renderReservedLocations(field.reservedLocations)}
        </Table.Cell>
        <Table.Cell width={2}>
          {this.renderNewLocation(index, field.newLocation || '')}
        </Table.Cell>
        <Table.Cell width={2}>
          {this.renderNewReservedLocations(index, field.newReservedLocations || [])}
        </Table.Cell>
        <Table.Cell>
          <Icon
            link
            name='trash'
            size='big'
            onClick={this.handleRemoveClick.bind(this, index)}
          />
        </Table.Cell>
      </Table.Row>
    );
  }

  checkRequiredField(value) {
    return value ? null : 'Requerido';
  }

  renderReservedLocations(reservedLocations = []) {
    return reservedLocations.map((element, index) => {
      return <div key={index}>{element}</div>;
    });
  }
  
  renderNewLocation(index, newLocation) {
    return <div className='location-container'>
      {this.getNewLocationValue(newLocation)}
      <Button icon onClick={() => {
        this.props.showNewLocationsModal(index);
      }}>
        <Icon name='search' />
      </Button>
    </div>;
  }

  renderNewReservedLocations(index, newReservedLocations) {
    return <div className='location-container'>
      {this.getNewReservedLocationsValue(newReservedLocations)}
      <Button icon onClick={() => {
        this.props.showNewReservedLocationsModal(index);
      }}>
        <Icon name='search' />
      </Button>
    </div>;
  }

  renderPartCode(index, field) {
    const {loadingPartInfo} = this.props;

    if (!field.partName) {
      return (
        <Input
          required
          name='partCode'
          value={field.partCode}
          onChange={this.handleFieldChange.bind(this, index)}
          onKeyDown={this.handlePartKeyDown.bind(this, index)}
          disabled={loadingPartInfo}
        />
      );
    }

    return <ShowReplacementPartModal partCode={field.partCode} />;
  }

  handleFieldChange(index, event, data) {
    const {value, name} = data;
    const isPartField = name === 'partCode';
    const fieldValue = isPartField ? toUpperCase(value) : value;

    this.props.updateAssignmentValue(index, name, fieldValue);
  }

  handlePartKeyDown(index, event) {
    if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
      return;
    }

    const {warehouse} = this.props;
    event.preventDefault();
    event.stopPropagation();

    this.props.getPartAssignment(
      warehouse,
      toUpperCase(event.target.value),
      index
    );
  }

  handleRemoveClick(index) {
    this.props.removeLocationAssignment(index);
  }

  render() {
    const {fields} = this.props;

    return <><Table.Body>{this.renderFields(fields)}</Table.Body>
      <NewLocationSearchModal handleFieldChange={this.handleFieldChange.bind(this)}/>
      <NewReservedLocationsSearchModal handleFieldChange={this.handleFieldChange.bind(this)}/></>;
  }

  getNewLocationValue(newLocation) {
    return newLocation;
  }

  getNewReservedLocationsValue(newReservedLocations) {
    return newReservedLocations.join(' ');
  }
}

const mapStateToProps = (state) => {
  return {
    'fields': state.locationsAssignment.assignments,
    'warehouse': state.locationsAssignment.warehouse,
    'freeLocations': state.locationsAssignment.freeLocations,
    'loadingPartInfo': state.locationsAssignment.loadingPartAssignment,
    'loadingAssignmentsList': state.locationsAssignment.loadingAssignmentsList,
  };
};


const {removeLocationAssignment, updateAssignmentValue, getPartAssignment,
  showNewLocationsModal, showNewReservedLocationsModal} =
  Actions;

const mapDispatchToProps = {
  removeLocationAssignment,
  updateAssignmentValue,
  getPartAssignment,
  showNewLocationsModal,
  showNewReservedLocationsModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(TableBody);
